import { useRiskProfileSocialEconomicRequest } from './useRiskProfileSocialEconomicRequest'
import { useRiskProfileSocialEconomicQuery } from './useRiskProfileSocialEconomicQuery'
import type { PropertiesQueryParams } from '../types/riskProfileProperties.types'

export function useEconomicSectorData(queryParams: PropertiesQueryParams | null) {
  const request = useRiskProfileSocialEconomicRequest({
    queryParams,
    widget: 'disruptionBySector',
  })
  const query = useRiskProfileSocialEconomicQuery(request)
  return { request, query }
}
